const inputChunkSeparator = (value: string) => {
  const part1 = value.substring(0, 3);
  const part2 = value.substring(3, 6);
  const part3 = value.substring(6);
  if (part3) return `${part1} - ${part2} - ${part3}`;
  else if (part2) return `${part1} - ${part2}`;
  else return part1;
};
export default inputChunkSeparator;
